import type { SteamBenchPreset } from './types';

/** The preset a new steam-room bench starts with. */
export const DEFAULT_STEAM_PRESET_ID = 'steam-a';

/** The steam benches Stenal builds, drawn in `Panche_Stenal.dxf`: served when the
 *  database holds none (offline, or a table with no steam rows yet). */
export const DEFAULT_STEAM_BENCH_PRESETS: SteamBenchPreset[] = [
  {
    id: 'steam-a', name: 'Steam A',
    profile: [
      { x: 435, y: 275 }, { x: 465, y: 275 }, { x: 465, y: 255 }, { x: 500, y: 255 }, { x: 500, y: 450.02 },
      { x: 0, y: 455.02 }, { x: 0, y: 0 }, { x: 405, y: 0 }, { x: 405, y: 255 }, { x: 435, y: 255 },
    ],
  },
  {
    id: 'steam-b', name: 'Steam B',
    profile: [
      { x: 484.53, y: 316.4, bulge: 0.269553 }, { x: 491.84, y: 402.63, bulge: 0.264896 }, { x: 408.96, y: 448.81 },
      { x: 0, y: 455 }, { x: 0, y: 0 }, { x: 375, y: 0 }, { x: 375, y: 244.8 }, { x: 394.36, y: 244.8 },
      { x: 394.36, y: 264.8 }, { x: 424.36, y: 264.8 }, { x: 424.36, y: 244.8 }, { x: 434.36, y: 244.8 },
    ],
  },
  {
    id: 'steam-c', name: 'Steam C',
    profile: [
      { x: 584.92, y: 327.56 }, { x: 584.92, y: 449.18 }, { x: 154.96, y: 454.86 }, { x: 61.68, y: 904 },
      { x: 0, y: 904 }, { x: 0, y: 0 }, { x: 470, y: 0 }, { x: 470, y: 244.8 }, { x: 487.51, y: 244.8 },
      { x: 487.51, y: 264.8 }, { x: 517.51, y: 264.8 }, { x: 517.51, y: 244.8 }, { x: 584.92, y: 244.8 },
    ],
  },
  {
    id: 'steam-d', name: 'Steam D',
    profile: [
      { x: 592.72, y: 409.28, bulge: 0.266071 }, { x: 522.97, y: 450 }, { x: 220, y: 454, bulge: -0.334453 },
      { x: 143.11, y: 511.91 }, { x: 69.91, y: 864.37, bulge: 0.354267 }, { x: 21, y: 904 }, { x: 0, y: 904 },
      { x: 0, y: 0 }, { x: 470, y: 0 }, { x: 470, y: 244.8 }, { x: 487.51, y: 244.8 }, { x: 487.51, y: 264.8 },
      { x: 517.51, y: 264.8 }, { x: 517.51, y: 244.8 }, { x: 527.51, y: 244.8 }, { x: 584.62, y: 327.13, bulge: 0.265733 },
    ],
  },
];

/** A steam preset's Baserow `data` blob — `kind` tells it from a sauna slat
 *  preset in the same table (and an older app, which needs `slats`, skips it). */
export function steamPresetBlob(p: SteamBenchPreset): Record<string, unknown> {
  return { kind: 'steam', id: p.id, name: p.name, profile: p.profile };
}

/** A parsed `data` blob back into a steam preset, or null when it is not one. */
export function steamPresetFromBlob(parsed: unknown, rowId: number): SteamBenchPreset | null {
  const o = parsed as { kind?: unknown; id?: unknown; name?: unknown; profile?: unknown } | null;
  if (!o || o.kind !== 'steam' || !o.id || !Array.isArray(o.profile)) return null;
  const profile = (o.profile as Array<{ x?: unknown; y?: unknown; bulge?: unknown }>)
    .map((q) => ({ x: Number(q.x), y: Number(q.y), ...(Number(q.bulge) ? { bulge: Number(q.bulge) } : {}) }))
    .filter((q) => Number.isFinite(q.x) && Number.isFinite(q.y));
  if (profile.length < 3) return null;
  return { rowId, id: String(o.id), name: String(o.name ?? o.id), profile };
}
